import React, {useState, useEffect}  from 'react';
import {Alert, Table} from 'react-bootstrap';
import {useNavigate, useParams, Link} from 'react-router-dom';
import axios from 'axios';
import {apiUrl, reportStartDateDiff, reportEndDateDiff} from '../../../../util/Api';
import PRContent from '../../components/PRContent';
import { toFactDate, fromFactDate, isFactDate } from '../../../../util/ChartUtils';


const PromptResponses = (props) => {

    const [errors, setErrors] = useState([]);
    const [prompt, setPrompt] = useState(null);
    const [responses, setResponses] = useState([]);
    const [datesForLink, setDatesForLink] = useState('');

    const promptId = props?.promptId ? props.promptId : null;
    let {accountKey, appKey, startFactDate, endFactDate } = useParams();

    let navigate = useNavigate();

    //console.log(`prompt: ${promptId}`)
    useEffect(() => {
        let linkDates = "";
        if(startFactDate != null && startFactDate != ""){
            linkDates = `/${startFactDate}`;
            if(endFactDate != null && endFactDate != "") {
                linkDates += `/${endFactDate}`;
            }
            setDatesForLink(linkDates);
        }

        let startDate = new Date();
        let endDate = new Date();
        let startFact = startFactDate;
        let endFact = endFactDate;

        if (!isFactDate(endFact)) {
            //console.log('endFactDate is null')
            endDate.setDate(endDate.getDate() - reportEndDateDiff);
            endFact = toFactDate(endDate);
        } else {
            //console.log('endFactDate is not null', endFact)
            endDate = fromFactDate(endFact);
        }

        if (!isFactDate(startFact)) {
            //console.log('startFactDate is null')
            startDate.setDate(endDate.getDate() - reportStartDateDiff);
            startFact = toFactDate(startDate);
        } else {
            //console.log('startFactDate is not null', startFact)
            startDate = fromFactDate(startFact);
        }

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            promptId: promptId,
            startDate: startFact,
            endDate: endFact
        }
        let isAuthError = false;
        if(promptId != null) {        
            axios.post(apiUrl + '/app-stats/prompt-flow',
                options, { withCredentials: true })
                .then((res) => {
                    if (res.data.status === 'ok') {
                        //clear errors 
                        if(errors?.length > 0) {
                            setErrors([])
                        }
                        if (res.data.responses !== null) {
                            setResponses(res.data.responses);
                        }
                        if (res.data.prompt !== null) {
                            setPrompt(res.data.prompt);
                        }
                    } else {
                        if (res.data.prompt !== null) {
                            setPrompt(res.data.prompt);
                        }
                        if(responses?.length > 0){
                            setResponses([])
                        }
                        let errorMsgs = [];
                        let redirectToLogin = false;
                        res.data.errors.forEach((error, i) => {
                            switch (error) {
                                case 'auth-expired':
                                case 'auth-error':
                                case 'no-auth':
                                case 'no-valid-account':
                                case 'no-permissions':
                                    //console.log('auth expired');
                                    isAuthError = true;
                                    redirectToLogin = true;
                                    break;
                                case 'no-app':
                                case 'no-valid-app':
                                    //console.log('no results')
                                    errorMsgs.push('There was no matching app.');
                                    break;
                                case 'no-prompt':
                                    //console.log('no results')
                                    errorMsgs.push('There was no matching prompt.');
                                    break;
                                case 'no-results':
                                    //console.log('no results')
                                    errorMsgs.push('There were no matching responses.');
                                    break;
                                default:
                                    //TODO: may want to just ignore - no sense showing anything?
                                    errorMsgs.push('There was an error retrieving responses.');
                            }
                        });
                        //don't call setErrors if not logged in as it throws an unmounted error
                        if (redirectToLogin) {
                            navigate('/login');
                            return;
                        }
                        if (!isAuthError) {
                            setErrors(errorMsgs);
                        }
                    }
                })
                .catch((err) => {

                });
            }

    },[promptId, accountKey, appKey, startFactDate, endFactDate]);

    const sortByInteractions = () => {
        let temp = [...responses]
        temp.sort((a,b) => (a.interactions < b.interactions) ? 1 : -1)
        setResponses(temp);
    }
    const sortByResponse = () => {
        let temp = [...responses]
        temp.sort((a,b) => (a.response < b.response) ? -1 : 1)
        setResponses(temp);
    }

    return (
        <>
        {/*<div className={promptId != null ? 'chart-card' : ''}> */}
        <div className='chart-card'>
            <div>
            {prompt != null ? (<div className='chat-bubble chat-bubble-in'><PRContent text={prompt.prompt} typeId={prompt.typeId} filepath={prompt.filepath} size='md'/></div>) : null}
            </div>
            {
                errors.length > 0 ? (
                    <Alert variant='danger' className='mt-3'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {
                responses.length > 0 ? (
                    <>
                        <Table borderless size='sm'>
                            <thead>
                                <tr>
                                    <th><span onClick={sortByResponse} role="button">response</span></th>
                                    <th className='text-end'><span onClick={sortByInteractions} role="button">interactions</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    responses.map((response, i) => (
                                        <tr key={'response.' + i} >
                                            <td ><div className='chat-bubble mb-3'><PRContent text={response.response} typeId={response.typeId} filepath={response.filepath} size='md'/></div></td>
                                            <td className='text-end'><Link to={`/account/${accountKey}/analytics/app/${appKey}/interactions${datesForLink}?promptId=${promptId}&responseId=${response.responseId}`}>{response.interactions}</Link></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </>
                ) : (
                    null
                )
            }
        </div>
        </>
    )
}

export default PromptResponses